import React, { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Modal, Form, Row, Col, InputNumber, Button, Typography, Card, Divider } from 'antd';
import { toast } from 'react-toastify'
import { ApplicationState } from '../../store'
import BankDepositItem from './BankDepositItem'
import NumberWithCommas from '../../helpers/NumberWithCommas'
import api from '../../helpers/api';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Text } = Typography

interface Props {
    isOpen: boolean
    onClose: () => void
    onOpen: () => void
}

interface DepositDecimalData {
    success: boolean
    baseAmount: number
    generatedAmount: number
    expiresAt: string
    expiresIn: number
    message: string
}

const BankDepositDecimal: FC<Props> = ({ isOpen, onClose, onOpen }) => {
    const [form] = Form.useForm()
    const [decimalModal, setDecimalModal] = useState<boolean>(false)
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
    const [isTimeOut, setIsTimeOut] = useState<boolean>(false)
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
    const [isOldDeposit, setIsOldDeposit] = useState<boolean>(false)
    const [dataAmount, setDataAmount] = useState<DepositDecimalData>()

    const depositToList = useSelector((state: ApplicationState) => state.deposit.depositToList)
    const depositToBanks = depositToList.filter((bank) => bank.bank !== 'truewallet')

    const secondsToMinutes = (seconds: number): string => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        const formattedTime = `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
        return formattedTime;
    }

    const handleSubmit = async () => {
        setIsOpenModal(false)
        onClose()
        form.validateFields()
            .then(async (values: any) => {
                if (values.amount <= 0) {
                    setIsSubmitting(false)
                    return false
                }
                try {
                    const res: DepositDecimalData = await api.post('/deposit/generate', {
                        amount: values.amount
                    })

                    // if (res.message === 'Unique deposit amount generated successfully') {
                        localStorage.setItem('deposit-decimal', JSON.stringify(res))
                    // }

                    // message	"Unique deposit amount generated successfully" ครั้งแรก
                    // message	"Using existing active deposit amount" ซ้ำ

                    setDataAmount(res)
                    setDecimalModal(true)
                    setIsTimeOut(false)
                } catch (error: any) {
                    toast.error(error.message as string)
                    setIsSubmitting(false)
                    setDecimalModal(false)
                    setIsTimeOut(false)
                }
            }).catch((errorInfo) => {

            });
    }

    const checkOldDeposit = async (amount: number) => {
        try {
            const res: DepositDecimalData = await api.post('/deposit/generate', {
                amount: amount
            })

            if (res.message === 'Using existing active deposit amount') {
                localStorage.setItem('deposit-decimal', JSON.stringify(res))

                setIsOpenModal(false)
                onClose()
                setDataAmount(res)
                setDecimalModal(true)
                setIsTimeOut(false)
                setIsOldDeposit(true)
            } else {
                localStorage.removeItem('deposit-decimal')
                setIsOpenModal(true)
                setIsOldDeposit(false)
            }
        } catch (error: any) {
            toast.error(error.message as string)
            setIsSubmitting(false)
            setDecimalModal(false)
            setIsTimeOut(false)
        }
    }

    const handleReAction = () => {
        localStorage.removeItem('deposit-decimal')

        setDecimalModal(false)
        setIsOldDeposit(false)
        setIsOpenModal(true)
        setIsOpenModal(true)
    }

    useEffect(() => {
        if (decimalModal && dataAmount) {
            const countdown = setInterval(() => {
                if (dataAmount?.expiresIn <= 0) {
                    clearInterval(countdown);
                    setIsTimeOut(true)
                    localStorage.removeItem('deposit-decimal')
                } else {
                    setDataAmount({ ...dataAmount, expiresIn: dataAmount?.expiresIn - 1 })
                }
            }, 1000);

            return () => clearInterval(countdown);
        }
    }, [decimalModal, dataAmount]); // eslint-disable-line

    useEffect(() => {
        if (isOpen) {
            const depositDecimal = localStorage.getItem('deposit-decimal')
            if (depositDecimal) {
                const data = JSON.parse(depositDecimal)
                checkOldDeposit(data.baseAmount)
            } else {
                setIsOpenModal(true)
            }
        }
    }, [isOpen]); // eslint-disable-line

    return (
        <>
            {/* Step 1 */}
            <Modal
                className="ant-modal-deposit"
                open={isOpenModal}
                title="โอนเงินผ่านธนาคาร"
                centered
                onCancel={() => { setIsOpenModal(false); onClose() }}
                footer={null}
            >
                <Form
                    form={form}
                    name="truewalletVoucherForm"
                    layout="vertical"
                    hideRequiredMark
                >
                    <Row>
                        <Col span={24}>
                            <Form.Item
                                name="amount"
                                label="จำนวนเงินที่ต้องการเติม"
                                rules={[
                                    { required: true, message: 'กรุณากรอกจำนวนเงินที่ต้องการเติม' },
                                    // { type: 'number', min: 100, message: 'กรุณากรอกจำนวนเงินขั้นต่ำ 100 บาท' }
                                ]}
                                style={{ marginBottom: 0 }}
                            >
                                <InputNumber
                                    placeholder="0"
                                    inputMode="numeric"
                                    prefix="฿"
                                    controls={false}
                                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={(value) => (typeof value === 'string' ? value.replace(/[^\d]/g, '') : '')}
                                    onKeyPress={(event) => {
                                        if (!/^[0-9.,\b]+$/.test(event.key) || event.key === '.' || event.key === ',') {
                                            event.preventDefault();
                                        }
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={isSubmitting}
                        disabled={isSubmitting}
                        onClick={handleSubmit}
                        style={{ margin: '16px 0 12px' }}
                        block
                    >
                        เติมเงิน
                    </Button>
                </Form>
            </Modal >

            {/* Step 2 */}
            <Modal
                className="ant-modal-deposit"
                open={decimalModal || isOldDeposit}
                title="โอนเงินผ่านธนาคาร"
                footer={null}
                onCancel={() => { setDecimalModal(false); setIsOldDeposit(false); setIsOpenModal(false); }}
                centered
            >
                {!isTimeOut && (
                    <>
                        <Card
                            title={null}
                            style={{ width: "100%", marginBottom: 16 }}
                        >
                            <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: 32 }}>โอนยอด <strong style={{ color: '#52c41a' }}>{NumberWithCommas(dataAmount?.generatedAmount, 2)}</strong> บาท</div>
                                <Text type='secondary'>กรุณาโอนภายใน <span style={{ color: 'red' }}> {secondsToMinutes(dataAmount?.expiresIn || 0)} </span> นาที</Text>
                            </div>
                        </Card>

                        <div className="notice-card danger">
                            <div className="notice-card-icon">
                                <img src="/icons/new/danger.svg" alt="notice icon" />
                            </div>
                            <Text className="notice-card-text">
                                ระบบจะเติมเงินอัตโนมัติ <Text type="danger"><strong><u>เมื่อโอนเงินพร้อมทศนิยมตรงกันเท่านั้น</u></strong></Text>
                            </Text>
                        </div>

                        <Divider />

                        <Text style={{ display: 'block', marginBottom: 8 }}>บัญชีรับโอน</Text>
                        {depositToBanks.map((bank) => (
                            <BankDepositItem bank={bank} key={bank.accountNumber} />
                        ))}

                        <div style={{ textAlign: 'center', marginTop: 16 }}>
                            <Button className="ant-btn-dark" style={{ display: 'block', width: '100%' }} onClick={() => handleReAction()}>ทำรายการใหม่</Button>
                        </div>
                    </>
                )}

                {/* หมดเวลาทำรายการ */}
                {isTimeOut && dataAmount && dataAmount?.expiresIn <= 0 && (
                    // หมดเวลาทำรายการ
                    <div style={{ textAlign: 'center', padding: '18px 0' }}>
                        <ExclamationCircleOutlined style={{ color: '#dc0303', fontSize: 56, marginBottom: 16 }} />
                        <div style={{ marginBottom: 12 }}>
                            <Text>หมดเวลาทำรายการ</Text>
                        </div>
                        <Button className="ant-btn-dark" onClick={() => { setDecimalModal(false); setIsOldDeposit(false); setIsOpenModal(true); }}>ทำรายการใหม่</Button>
                    </div>
                )}

            </Modal>
        </>
    )
}

export default BankDepositDecimal
